<template>
    <div class="photo-album">
        <div class="album-list row " v-if="!photoAlbum && photoAlbums.length > 1">
            <div class="col-xs-6 col-sm-4 col-md-3 album" :key="idx3" v-for="(album, idx3) in photoAlbums" @click="openAlbum(idx3)">
                <div class="thumb">
                    <div class="photo" :key="idx4" v-for="(thumb, idx4) in album.photos.slice(0,4)" :style="{backgroundImage:`url(${thumb.src}?w=240)`}">
                        <img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
                    </div>
                    </div>
                    <div class="title">{{album.name && album.name[lang] || tr.untitled}}</div>
                </div>
            </div>
            <div class="album-view" v-if="photoAlbum || photoAlbums.length === 1">
                <div class="row no-gutters ">
                    <div class="col-sm-4 col-md-3 go-back-contaienr" v-if="photoAlbums.length > 1" @click="back">
                        <div class="go-back">
                            <div class="btn"><span class="fal fa-arrow-left"></span> Назад</div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-3 " :key="i" v-for="(photo,i) in photoAlbum.photos">
                        <div class="photo-item" :style="{backgroundImage:`url(${photo.src}?w=350)`}" @click="openPhoto(i)">
                            <img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
                            <!-- <div class="title">
                                {{photo &&photo.title || tr.untitled}}
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import _ from "lodash";
export default {

    name: 'i-photos',
    props: ["value"],
    methods: {
        back() {
            this.currentIdx = false;

        },
        openPhoto(index) {
            this.$store.commit('openPhoto', { list: this.photoAlbum.photos, index });
        },
        openAlbum(idx) {
            this.currentIdx = idx;
        }
    },
    mounted() {
        if (this.value.length === 1) {
            this.currentIdx = 0;
        } else
            this.currentIdx = false;
    },
    data() {
        return {
            currentIdx: false
        }
    },
    computed: {
        photoAlbums() {
            return this.value;
        },
        photoAlbum() {
            return this.value[this.currentIdx] ? this.value[this.currentIdx] : false;
        }
    }
}
</script>
<style lang="css" scoped>
.photo-item {
    background-size: cover;
    background-position: center;
    margin: 5px;
    transition: 0.2s all ease;
    cursor: pointer;
    overflow: hidden;

    border-radius: 4px;
    transform: scale(1.0);
}

.photo-item:hover {
    transform: scale(1.05);
}

.photo-item:hover .title {
    margin-top: -30px;

}

.photo-item .title {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 6px;
    position: absolute;
    margin-top: 0px;
    width: 100%;
    transition: 0.3s all ease;
}


.album .thumb {}

.album .title {
    text-align: center;
    margin-top: 8px;
}

.album {
    margin-bottom: 10px;
    cursor: pointer;
}

.thumb .photo {
    background-size: cover;
    background-position: center;
    width: 48%;
    display: inline-block;
    transition: 0.2s all ease;
    border-radius: 4px;
    margin:1%;
    overflow:hidden;
}

.thumb .photo:hover {
    transform: scale(1.04);
}

.go-back {
    background: rgba(0, 0, 0, 0.76);
    padding: 4px 8px;
    color: white;
    border-radius: 4px;
    font-size: 20px;
    cursor: pointer;
    text-align: center;
    transition: 0.3s all ease;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}

.go-back .fal {
    font-size: 18px;
}

.go-back .btn {}

.go-back:hover {
    background: rgba(0, 0, 0, 0.55);
}


.go-back-contaienr {
    padding: 6px;
}
</style>